/* @flow */

import * as React from "react";

import * as _ from "lodash";
import { FormattedMessage } from "react-intl";
import { FormGroup } from "react-bootstrap";
import { ThreeStateToggle } from "../../../general/ThreeStateToggle";
import { FacetResult } from "shared/src/types/articlesearch/Facets";

type BoolFacetProps = {
    facet: FacetResult;
    value: boolean | null;
    onChange: (key: string, newValue: null | boolean) => void;
    className: string; // currently only for testing, not actually applied
};

export class BoolFacet extends React.Component<BoolFacetProps> {
    handleChange = (newValue: boolean | null) => {
        this.props.onChange(this.props.facet.key, newValue);
    };

    render() {
        const props = this.props;
        const facetName = !_.isEmpty(props.facet.name) ? (
            props.facet.name
        ) : (
            <FormattedMessage id={"EX_FILTER_PANEL_FACET_CAPTION_" + props.facet.key.toUpperCase()} />
        );
        const trueValue = _.find(props.facet.values, (value) => value.name === "true") || { amount: 0 };
        return (
            <FormGroup>
                <ThreeStateToggle value={props.value} onChange={this.handleChange} />
                <div className="input-range-boolean-label">
                    {facetName} ({trueValue.amount})
                </div>
            </FormGroup>
        );
    }
}
